import get from 'lodash.get';
import status from 'src/js/modules/status';
import statusNames from '../constants/status-names';

const getCreateCancellationCouponStatus = (rootState) =>
  get(status.selectors.getStatus(rootState), statusNames.CREATE_CANCELLATION_COUPON);

export default getCreateCancellationCouponStatus;
